import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import { EmailIcon, PhoneIcon } from '@/assets/images';
import type SearchConstituent from '@/types/api/SearchConstituent';
import {
  getPrimaryEmail,
  getPrimaryPhoneNumber,
} from '@/utils/constituentUtils';
import PopoverMenuType from '../constants/PopoverMenuType';

function ConstituentActions({
  className = '',
  constituent,
  fullWidth = false,
  onMenuClick = () => {},
}: {
  className?: string;
  constituent: SearchConstituent;
  fullWidth?: boolean;
  onMenuClick: (
    e: React.MouseEvent,
    constituent: SearchConstituent,
    menu: PopoverMenuType,
  ) => void;
}) {
  const { emails, primaryEmail, primaryPhone, phones = [] } = constituent;
  const email = primaryEmail || getPrimaryEmail(emails);
  const phone = primaryPhone || getPrimaryPhoneNumber(phones);
  const buttonClasses = fullWidth ? 'bg-grey-100 rounded-lg w-full' : '';

  return (
    <div
      className={classNames(
        'flex items-center',
        { 'w-full flex-col gap-3': fullWidth },
        className,
      )}
    >
      {email && (
        <Tooltip title={email} arrow>
          <IconButton
            onClick={(e) => onMenuClick(e, constituent, PopoverMenuType.EMAIL)}
            size="large"
            className={buttonClasses}
          >
            <EmailIcon className="text-tertiary-main" />
          </IconButton>
        </Tooltip>
      )}
      {phone && (
        <Tooltip title={phone} arrow>
          <IconButton
            onClick={(e) => onMenuClick(e, constituent, PopoverMenuType.PHONE)}
            size="large"
            className={buttonClasses}
          >
            <PhoneIcon className="text-tertiary-main" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}

export default ConstituentActions;
